import { jsxs as c, jsx as l } from "react/jsx-runtime";
import { clsx as n } from "../../../utils/clsx.js";
import '../../../assets/Page.css';const d = "_root_18k7e_1", _ = "_loader_18k7e_8", m = "_wtf_18k7e_1", o = {
  root: d,
  loader: _,
  wtf: m
};
function w(s) {
  const {
    children: r,
    className: t,
    showLoader: e = !1
  } = s, a = n(o.root, t);
  return /* @__PURE__ */ c("div", { className: a, children: [
    r,
    e && /* @__PURE__ */ l("div", { className: o.loader })
  ] });
}
export {
  w as Page
};
